import { forwardRef } from "react"; // Добавляем forwardRef
import s from "./ImageInput.module.css";

const ImageInput = forwardRef(
  ({ onChange, label, required, accept, preview, onPreviewClear }, ref) => {
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      if (onChange) onChange(file);
    };

    return (
      <div className={s.imageInput}>
        {label && <label>{label}</label>}
        <input
          type="file"
          accept={accept}
          onChange={handleFileChange}
          required={required}
          ref={ref} // Передаем ref в input
        />

        {preview && (
          <div className={s.preview}>
            <img
              src={preview}
              alt="Preview"
              style={{ maxWidth: "300px", maxHeight: "200px" }}
            />
          </div>
        )}
      </div>
    );
  }
);

export default ImageInput;
